import { useStorageSlot } from '@gonfalon/browser-storage/useStorageSlot';
import { trackRecentProjects } from '@gonfalon/dogfood-flags/dogfood-flags';

import { cacheKey } from './config';

export function useRecentProjectStorage() {
  return useStorageSlot(cacheKey, { isEnabled: trackRecentProjects() });
}
